import {UserLevel} from '@netx/core-user-next/constants';

export enum ConstituentsPref {
	CLIPS_ENABLED = 'asset.constituent.videoClips.enabled',
}

export enum ConstituentType {
	KEYFRAME = 1,
	LAYER = 2,
	PAGE = 3,
	VIDEO_CLIP = 4,
}

export const SEARCH_CONSTITIUENT_CLIPS_MINIMUM_USER_LEVEL = UserLevel.CONSUMER;
